import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { OrderedMap } from 'immutable';
import get from 'lodash/get';

import Dropdown from 'components/vehicles/modal/license-plate/dropdown';

const propTypes = {
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  vehicleId: PropTypes.number,
  onDropdownSelect: PropTypes.func.isRequired,
};

const defaultProps = {
  vehicleId: null,
};

const LicensePlateModalSelectVehicle = ({
  vehicles,
  onDropdownSelect,
  vehicleId,
}) => {
  if (!get(vehicles, 'size', 0) > 0) { return null; }

  return (
    <div className="license-plate-section license-plate-divider">
      <div className="license-plate-title">
        <FormattedMessage
          id="parking-pass.select-vehicle"
          defaultMessage="SELECT YOUR VEHICLE"
        />
      </div>
      <Dropdown
        onSelect={onDropdownSelect}
        vehicles={vehicles}
        selectedVehicleId={vehicleId}
      />
      <div style={{ clear: 'both' }} />
    </div>
  );
};

LicensePlateModalSelectVehicle.propTypes = propTypes;
LicensePlateModalSelectVehicle.defaultProps = defaultProps;
export default LicensePlateModalSelectVehicle;
